import type { Resource } from '../types/content'

export const mainGuide: Resource = {
  id: 'guida',
  kind: 'guide',
  label: 'Guida pratica',
  name: 'Tricotin con Amore',
  benefit: 'Le basi per iniziare, con un percorso chiaro da seguire.',
  description:
    'Scopri materiali e strumenti, impara a preparare il cordoncino e avvicinati alla modellatura e alle rifiniture. Una guida da consultare mentre fai pratica e dai forma alle tue prime idee.',
  image: 'https://cdn.magicpatterns.com/uploads/2TC7wZJPv4nVDQ7tbkaPMx/TRICOTIN_CON_AMORE.png',
  imageAlt:
    'Copertina del libro Tricotin con Amore, con la scritta Amore in cordoncino rosa, il nome Sofia, una mongolfiera, un fiore e un cuore in tricotin',
}

export const templateLibrary: Resource = {
  id: 'collezione',
  kind: 'collection',
  label: 'Cartamodelli',
  name: 'La Collezione Creativa',
  benefit: 'Riferimenti di forma da stampare',
  description:
    'Una raccolta di riferimenti da stampare per scegliere una forma, fare pratica e continuare a creare con nuove idee.',
  // Da verificare: la copertina riporta « 300 modelli », numero non ancora confermato.
  image: 'https://cdn.magicpatterns.com/uploads/gLvFndcqujFv7qNVNHm88B/2B300_MODELLI.png',
  imageAlt:
    'Copertina di La Collezione Creativa di Tricotin con Amore, appoggiata su fogli di cartamodelli con lettere, numeri, cuori, fiori e animali',
}

export const bonuses: Resource[] = [
  {
    id: 'idee-decorazione',
    kind: 'bonus',
    number: 1,
    label: 'Bonus 1',
    name: 'Oltre 100 idee di decorazione in Tricotin',
    benefit: 'Trova l’ispirazione per il tuo prossimo progetto.',
    description:
      'Una raccolta di idee per esplorare forme, colori e dettagli decorativi da reinterpretare con il tuo gusto.',
    // Da sostituire: la copertina fornita riporta il titolo precedente
    // « Oltre 100 idee creative in Tricotin ».
    image: 'https://cdn.magicpatterns.com/uploads/6GpVwmptAyVbJwyyxL7u8y/2B100_idee_creative.png',
    imageAlt:
      'Copertina della raccolta di idee in Tricotin su un tavolo di legno, circondata da un tricotin a manovella, gomitoli, filo metallico, pinze e forme in cordoncino: luna, stella, dinosauro, casetta e farfalla',
  },
  {
    id: 'portachiavi',
    kind: 'bonus',
    number: 2,
    label: 'Bonus 2',
    name: 'Portachiavi personalizzati in Tricotin',
    benefit: 'Piccoli accessori con un tocco personale.',
    description:
      'Scopri materiali, forme e rifiniture per creare portachiavi con iniziali, cuori, fiori e altri piccoli dettagli.',
    image: 'https://cdn.magicpatterns.com/uploads/wowjBkVvaMh2VE8ChR4ws5/portachiavi.png',
    imageAlt:
      'Copertina di Portachiavi personalizzati in Tricotin circondata da portachiavi a forma di fiore, cuore e lettera',
  },
  {
    id: 'penne',
    kind: 'bonus',
    number: 3,
    label: 'Bonus 3',
    name: 'Penne decorate in Tricotin',
    benefit: 'Un dettaglio creativo anche negli oggetti di ogni giorno.',
    description:
      'Idee e indicazioni per personalizzare penne con piccole decorazioni in tricotin, curando proporzioni, fissaggio e praticità.',
    image: 'https://cdn.magicpatterns.com/uploads/tCTgwf262YyjgBGNnL4oCk/penne.png',
    imageAlt:
      'Copertina di Penne decorate in Tricotin tra penne pastello decorate con fiori in cordoncino',
  },
  {
    id: 'bomboniere',
    kind: 'bonus',
    number: 4,
    label: 'Bonus 4',
    name: 'Oltre 100 idee per bomboniere in Tricotin',
    benefit: 'Piccoli pensieri per occasioni da ricordare.',
    description:
      'Una raccolta di ispirazioni per bomboniere e dettagli da regalare, con idee di colori e presentazione.',
    // Da sostituire: la copertina fornita riporta il titolo precedente
    // « Piccoli regali e bomboniere in Tricotin ».
    image: 'https://cdn.magicpatterns.com/uploads/jYA96rz4pXERdojQB2v288/regali.png',
    imageAlt:
      'Copertina della guida sulle bomboniere in Tricotin tra sacchetti e scatoline decorati con cuori, stelle e fiori in cordoncino',
  },
]

/** Ordine del pack: guida, collezione, poi i 4 bonus. */
export const allResources: Resource[] = [mainGuide, templateLibrary, ...bonuses]
